/** Strip a single provider prefix (`cognito:admin` → `admin`) and lowercase. */
export const normalizeRole = (value) => {
  const s = String(value ?? '')
    .toLowerCase()
    .trim();
  return s.includes(':') ? s.split(':').pop() : s;
};

const resolvePrivilegedRoles = () => {
  const configured = [
    process.env.REACT_APP_ADMIN_GROUP,
    process.env.REACT_APP_MODELLING_GROUP,
    process.env.REACT_APP_DOMAIN_MODELLING_GROUP,
  ]
    .map(normalizeRole)
    .filter(Boolean);

  if (configured.length === 0) {
    if (process.env.NODE_ENV === 'production') {
      // Fail closed: do not grant the UI affordance on misconfiguration.
      console.error(
        '[config/roles] REACT_APP_ADMIN_GROUP / REACT_APP_MODELLING_GROUP / ' +
          'REACT_APP_DOMAIN_MODELLING_GROUP are not set; privileged UI (deprecate, manage release) ' +
          'will be hidden. Configure these env vars.'
      );
      return [];
    }
    console.warn(
      '[config/roles] REACT_APP_ADMIN_GROUP / REACT_APP_MODELLING_GROUP / ' +
        "REACT_APP_DOMAIN_MODELLING_GROUP are not set; falling back to defaults ['admin', 'modelling'] " +
        'for development.'
    );
    return ['admin', 'modelling'];
  }

  return configured;
};

/**
 * Roles allowed to perform privileged release operations, resolved from env at
 * module load. Per environment these are the admin/modelling Cognito groups —
 * e.g. dev: `DLI_Admin_dev` + `DLI_Modelling_dev` + `dli-eu-c-1-modelling-lab-role-dev`
 * (see .gitlab/variables.yml).
 */
export const PRIVILEGED_ROLES = resolvePrivilegedRoles();

/** Roles allowed to deprecate a release. Same set as {@link PRIVILEGED_ROLES}. */
export const DEPRECATE_ROLES = PRIVILEGED_ROLES;

/** Roles allowed to open Manage Release. Same set as {@link PRIVILEGED_ROLES}. */
export const MANAGE_RELEASE_ROLES = PRIVILEGED_ROLES;
